module.exports = __webpack_public_path__ + "img/17.5b35ef8e.jpg";